
export enum AccountStatus {

  /**
   * Available, but not yet requested.
   */
  AVAIL,

  /**
   * Requested, but not yet available.
   */
  PEND,

  /**
   * Active.
   */
  ACTIVE

}
